import { MaskedLines, Reveal } from "./Reveal";
import { ButtonLink } from "./Buttons";
import { site } from "../config/site";

export default function CTASection() {
  return (
    <section
      className="grain-dark relative overflow-hidden bg-ink py-24 md:py-36"
      data-testid="final-cta-section"
    >
      <span
        aria-hidden="true"
        className="pointer-events-none absolute -right-16 top-1/2 hidden -translate-y-1/2 select-none font-display text-[24rem] italic leading-none text-outline-light lg:block"
      >
        &
      </span>
      <div className="container-x relative">
        <Reveal>
          <div className="flex items-center gap-4">
            <p className="eyebrow-light">{site.fullName}</p>
            <span className="h-px w-12 bg-champagne/50" aria-hidden="true" />
          </div>
        </Reveal>
        <h2 className="mt-6 font-display text-[clamp(2.4rem,6vw,5rem)] font-medium leading-[1.02] text-ivory">
          <MaskedLines
            lines={[
              <>Ready for Your</>,
              <>
                Next <em className="italic text-champagne">Look?</em>
              </>,
            ]}
          />
        </h2>
        <Reveal delay={0.3}>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-ivory/70 md:text-lg">
            Tell us what you're looking for and get in touch with Glow &amp;
            Blow for your next salon visit.
          </p>
        </Reveal>
        <Reveal delay={0.45}>
          <div className="mt-10 flex flex-wrap gap-4">
            <ButtonLink to="/book" variant="gold" data-testid="cta-book-btn">
              Book an Appointment
            </ButtonLink>
            <ButtonLink
              href={site.phoneHref}
              variant="outlineLight"
              arrow={false}
              data-testid="cta-call-btn"
            >
              Call the Salon
            </ButtonLink>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
